import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { AcrListState } from "@reducers/types/HRM/acr-list-state";

import { getAcrListRequest } from "@actions/HRM/acr/acr-list-actions";
import { getAcrListState } from "@selectors/HRM/acr/acr-list-selectors";

import { useAppSelector } from "@helpers/redux";
import { PaginationType } from "@type/HRM/pagination";
import { AcrListResponseType, AcrType } from "@type/HRM/acrs";

interface UseAcrList {
  acrListRequest: boolean;
  acrListSuccess: boolean;
  acrListFailed: boolean;
  acrList: AcrType[];
  pagination: PaginationType;
  handleQuery: (params: Partial<StateType>) => void;
}

interface StateType {
  page: number;
  size: number;
  eligible: boolean | null;
  [key: string]: any;
}

export const useAcr = (): UseAcrList => {
  const [query, setQuery] = useState<StateType>({
    page: 1,
    size: 10,
    eligible: null,
    isActiveEmployee: true,
  });

  const handleQuery = (params: Partial<StateType>) =>
    setQuery((prev) => ({
      ...prev,
      ...params,
    }));

  const getAcrList = useAppSelector<AcrListState>(getAcrListState);

  const acrListRequest = getAcrList.request as boolean;
  const acrListSuccess = getAcrList.success as boolean;
  const acrListFailed = getAcrList.failed as boolean;
  const { data: acrList, pagination } = getAcrList.data
    ? getAcrList.data
    : ({} as AcrListResponseType);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAcrListRequest(query));
  }, [dispatch, query]);

  return {
    handleQuery,
    acrListRequest,
    acrListSuccess,
    acrListFailed,
    acrList,
    pagination,
  };
};
